import DataGrid, { Column } from 'devextreme-react/data-grid';

const NoFurtherActionPortfolioTable = ({ data }) => {
    const onAddressCellRender = (e) => {
        if (e.data.address.street2) {
            return e.data.address.street1 + ', ' + e.data.address.street2;
        } else {
            return e.data.address.street1;
        }
    };

    if (!data || data.length === 0) {
        return '';
    }

    return (
        <DataGrid
            dataSource={data}
            showBorders={true}
            showRowLines={false}
            rowAlternationEnabled={true}
            remoteOperations={false}
            allowColumnReordering={false}
            allowColumnResizing={true}
            width={'80%'}
            cellHintEnabled={true}
        >
            <Column
                dataField='address.street1'
                caption='Address'
                cellRender={onAddressCellRender}
            />
            <Column
                dataField='address.city'
                caption='City'
                width={150}
            />
            <Column
                dataField='address.state'
                caption='State'
                width={70}
            />
            <Column
                dataField='address.zipCode'
                caption='Zip'
                width={70}
            />
            <Column
                dataField='bfiNumber'
                caption='BFI #'
                dataType='string'
                width={100}
            />
        </DataGrid>
    );
};

export default NoFurtherActionPortfolioTable;
